import React, { Component } from 'react'
import styled from 'styled-components'
import CloseIcon from '../Icons/CloseIcon'
import { device } from '../../../utils/helpers'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const InnerWrapper = styled.div`
  text-align: center;
  justify-content: center;
  align-items: center;
`

const IconWrapper = styled.div`
  text-align: right;
`

const Icon = styled(CloseIcon)`
  cursor: pointer;
  width: 20px;

  &:hover {
    fill: ${props => props.theme.color.hoverPrimary};
  }

  @media ${device.tablet} {
    width: 1.5625VW;
  }
`

const Title = styled.h3`
  font-size: 20px;
  font-family: 'BarlowExtraBold';
  text-transform: uppercase;
  padding-bottom: 30px;

  @media ${device.tablet} {
    font-size: 1.4583333333333333VW;
    line-height: 1.25em;
  }
`

const Subtitle = styled.p`
  padding-bottom: 30px;
  font-size: 16px;

  @media ${device.tablet} {
    font-size: 1.09375VW;
    line-height: 1.25em;
  }
`

const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
`

const Button = styled.button`
  font-family: 'BarlowExtraBold';
  display: inline-block;
  outline: none;
  font-size: 18px;
  color: #fff;
  border: 5px solid #4d4d4d;
  background-color: #4d4d4d;
  padding: 6px 35px;
  text-transform: uppercase;
  transition: all 0.5s ease;
  cursor: pointer;

  &:hover {
    color: white;
    background-color: ${props => props.theme.color.hoverPrimary};
    border: 5px solid ${props => props.theme.color.borderSecondary};
  }

  @media ${device.tablet} {
    font-size: 1.25VW;
    padding: 0.5729166666666666VW 2.864583333333333VW;
  }
`

class ConfirmPopup extends Component {
  closeIconClick () {
    this.props.closeModal()
  }

  yesClick () {
    this.props.confirm()
    this.props.closeModal()
  }

  render () {
    let { title, subtitle } = this.props
    // Add line breaks to string by checking for ;
    if (typeof title === 'string' && title.includes(';')) {
      title = title.split(';').map((item, key) => {
        return <span key={key}>{item}<br /></span>
      })
    }

    if (typeof subtitle === 'string' && subtitle.includes(';')) {
      subtitle = subtitle.split(';').map((item, key) => {
        return <span key={key}>{item}<br /></span>
      })
    }

    return (
      <Wrapper>
        <IconWrapper>
          <Icon fill='#4d4d4d' onClick={this.closeIconClick.bind(this)} />
        </IconWrapper>
        <InnerWrapper>
          <Title>
            {title}
          </Title>
          {subtitle && <Subtitle>
            {subtitle}
          </Subtitle>}
          <Buttons>
            <Button onClick={this.yesClick.bind(this)}>
              SÌ
            </Button>
            <Button onClick={this.closeIconClick.bind(this)}>
              No
            </Button>
          </Buttons>
        </InnerWrapper>
      </Wrapper>
    )
  }
}

export default ConfirmPopup



// WEBPACK FOOTER //
// ./src/components/UI/Modals/ConfirmPopup.js